import { Box, Divider, Grid, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import { PageTitle } from '../../../layoutPages/components/PageTitle';
import { CourseTab } from '../menuTab';
import { HaveImage, Paragraph } from '../../../layoutPages/containers/Paragraphs/Paragraph';
import { TabDefaultSetting } from '../../../layoutPages/defaultSetting';
import { DottedList } from '../../../layoutPages/containers/DottedList';
import { MainCard } from '../../../layoutPages/components/MainCard';
import ChangeHistoryTwoToneIcon from '@mui/icons-material/ChangeHistoryTwoTone';
import StarsIcon from '@mui/icons-material/Stars';
import { mathMenuData } from '../../../data/SubjectMenu/mathMenuData';

export function PageMathsConcern() {

    const isPc = useMediaQuery('(min-width:600px)');

    let dottedListData = [
        "透過慶祝3月14 日「國際數學日」（Pi Day），設計各種與π相關的遊戲和競賽，豐富學生多元學習經歷。活動滲入中華文化元素，提升學習數學的興趣和熱愛，營造愉快的學習數學氛圍。"
    ];

    let dottedListData2 = [
        "優化數學科小一數學繪本教學，拓展校本繪本教學策略。",
        "選取合適的課題，透過課堂教學或課後延伸滲入中國數學歷史的知識，擴闊「家國情懷」之情。",
        "透過「國際數學日」(3月14日)，與圖書館合作。善用多元閱讀資源，舉辦主題式閱讀活動，以推動同學對中國數學家與西方數學歷史文化的認識，從中擴闊視野及享受閱讀的樂趣。"
    ]

    return (
        <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>
            <PageTitle title='數學科 | 年度重點項目' size='h3' subtitle={{ title: 'CURRENT MAIN CONCERN', size: 'h5' }} />
            <Grid item xs={11} sm={10}>
                <CourseTab data={mathMenuData} nowIndex={2} />
                <MainCard src="https://www.pkps.edu.hk/img/teachplan/maths/concern/top.jpg" noImgPopup={true} />
            </Grid>

            <Grid item xs={11} sm={10} sx={{ p: 2 }}>

                <Typography variant="h4" align={"left"} sx={{ pt: 2, color: "#F02602" }} >1.運用多元的思維策略/工具，著力培養學生探究技能；</Typography>
                <Paragraph title="" titleSize='h5'
                    data={[
                        <DottedList data={["加強高階思維訓練教學，培養學生善用不同的高階思維工具來解決問題。", "開展小二利用「模型思考法」(Model Method)進行應用題教學，加強學生理解及分析題目的能力，幫助學生解題和掌握數學概念"]} variant={<StarsIcon fontSize='small' />} />
                    ]}
                    haveImage={{
                        images: [
                            { src: "https://www.pkps.edu.hk/img/teachplan/maths/concern/2526-1.png" },
                            { src: "https://www.pkps.edu.hk/img/teachplan/maths/concern/2526-2.png" },
                        ],

                        position: "down",
                        imageHeight: "400px",
                    }}
                />

                <Paragraph title="" titleSize='h5'
                    data={[
                        <DottedList data={["優化低小「數學挑戰站」內容，提供更多情境讓學生應用所學。", "累積探究式數學教學設計，激發學生思考、驗證假設並歸納結論，以培養他們的數學素養和探究能力。"]} variant={<StarsIcon fontSize='small' />} />
                    ]}
                    sx={{ mb: 3 }}
                />

                <Typography variant="h4" align={"left"} sx={{ pt: 5, color: "#F02602" }} >2. 融入AI、編程等科技學習元素，培養學生創造性思考能力及解決問題能力；</Typography>

                <Paragraph title="" titleSize='h5'
                    data={[
                        <DottedList data={["以研究課持續優化素養導向的教學設計，融入AI或科技的應用，以促進學生的創新思維和解決問題的能力。"]} variant={<StarsIcon fontSize='small' />} />
                    ]}
                    haveImage={{
                        images: [
                            { src: "https://www.pkps.edu.hk/img/teachplan/maths/concern/2526-3.jpg" }
                        ],

                        position: "down",
                        mainCardProps: {
                            imgSx: { maxWidth: "800px", display: "block", margin: "0 auto" },
                            noHoverAni: true
                        }
                    }}
                />

                <Paragraph title="" titleSize='h5'
                    data={[
                        <DottedList data={["選取更多合適的課題加入編程、科探元素進行學習或試後活動，以提升學生的實踐能力和探索精神。"]} variant={<StarsIcon fontSize='small' />} />
                    ]}
                    haveImage={{
                        images: [
                            { src: "https://www.pkps.edu.hk/img/teachplan/maths/concern/2526-4.jpg" },
                            { src: "https://www.pkps.edu.hk/img/teachplan/maths/concern/2425-2.jpg" }
                        ],

                        position: "down",
                        imageHeight: "400px",

                    }}
                />

                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <MainCard
                        src="https://www.pkps.edu.hk/img/teachplan/maths/concern/2526-6.png"
                        imgHeight="650px"
                        imgSx={{ display: "block", margin: "0 auto" }}
                        noHoverAni={true}
                    />
                </Grid>

                <Paragraph title="" titleSize='h5'
                    data={[
                        <DottedList data={["設計虛擬實境的AR閱讀「方」(小五)，結合先進科技促進跨學科學習（包括中文和數學），以提升學生對科普書籍的興趣和互動體驗。"]} variant={<StarsIcon fontSize='small' />} />
                    ]}
                    haveImage={{
                        images: [
                            { src: "https://www.pkps.edu.hk/img/teachplan/maths/concern/2526-7.jpg" },
                            { src: "https://www.pkps.edu.hk/img/teachplan/maths/concern/2526-8.png" }
                        ],
                        position: "down",
                        imageHeight: "400px",
                    }}
                />

                <Paragraph title="" titleSize='h5'
                    data={[
                        <DottedList data={["於「國際數學日」（Pi Day）滲入新興科技VR體驗，引發學生對新興科技的興趣。"]} variant={<StarsIcon fontSize='small' />} />
                    ]}
                    haveImage={{
                        images: [
                            { src: "https://www.pkps.edu.hk/img/teachplan/maths/concern/2526-9.png" },
                        ],
                        position: "down",
                        mainCardProps: {
                            imgSx: { maxWidth: "1000px", display: "block", margin: "0 auto" },
                            noHoverAni: true
                        }
                    }}
                />


                <Typography variant="h4" align={"left"} sx={{ pt: 2, color: "#F02602" }} >3. 豐富學生多元學習經歷，滲透「勤學」、「孝親」價值觀教育。</Typography>
                <Paragraph title="" titleSize='h5'
                    data={[
                        <DottedList data={["推廣服務學習與生命教育-發揚「老吾老，以及人之老」的精神，透過探訪及與長者齊玩RUMMIKUB(魔力橋)，提升學生對職業生涯規劃(社工)的認識及培養正向價值觀(孝親)。"]} variant={<StarsIcon fontSize='small' />} />
                    ]}
                    haveImage={{
                        images: [
                            { src: "https://www.pkps.edu.hk/img/teachplan/maths/concern/2526-10.jpg" },
                        ],
                        position: "down",
                        mainCardProps: {
                            imgSx: { maxWidth: "1000px", display: "block", margin: "0 auto" },
                            noHoverAni: true
                        }
                    }}
                />


                <Paragraph title="" titleSize='h5'
                    data={[
                        <DottedList data={["在教學、課業融入數學家故事及數學史，連結勤學，讓學生知道所有數學成就背後都是堅持不懈的努力。", "善用數學珍藏本(筆記)，記錄重點、難題、錯題及學習反思，將勤學的具體行為變成一種習慣和常規。", "善用「現代評核及跟進系統(MDR)」，培養學生勤奮向學，定期鞏固及跟進所學。"]} variant={<StarsIcon fontSize='small' />} />
                    ]}
                />
            </Grid>




        </Grid>
    )
}
